/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MultiplierLvlDto {
  lvl: number;
  /**
   * Multiplier for base spread setting.
   */
  shortPosition: number;
  /**
   * Multiplier for base spread setting.
   */
  longPosition: number;
}
